<mat-card [class.mh-250]="this.recentActivity && this.recentActivity?.length > 0 && !loading"
          class="overflow-hidden recentActivityCard halfSideBar">
    <mat-card-header [style.background-color]="community?.recent_activity_header_bg_color_hex" class="noDarkMode">
        <div mat-card-avatar>
            <mat-icon
                    [style.color]="this.themeService.getReadableColor(community?.recent_activity_header_bg_color_hex)">
                access_time
            </mat-icon>
        </div>
        <mat-card-title
                [style.color]="this.themeService.getReadableColor(community?.recent_activity_header_bg_color_hex)">
            <div [innerHTML]="community?.recent_activity_tile_name_rendered || 'Recent activity'"
                 class="noMargin"></div>
        </mat-card-title>
    </mat-card-header>
    <div *ngIf="isDialog" class="float-end">
        <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                tabindex="-1">
            <mat-icon [style.color]="this.themeService.getReadableColor(community?.recent_activity_header_bg_color_hex)"
                      class="accent-text">
                close
            </mat-icon>
        </button>
    </div>
    <mat-card-content class="activityScroll pt-10">
        <div *ngIf="loading" class="flex-row justify-content-center">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
        <div class="flex-col w-100">
            <ng-container *ngFor="let content of this.recentActivity; let last = last;">
                <div class="flex-row w-100 gap-15">

                    <div class="flex-col align-items-center">
                        <div class="circle"></div>
                        <div *ngIf="!last" class="line"></div>
                    </div>
                    <div (click)="link(content)" class="flex-col pb-15 clickable flex-1 p-5">
                        <p *ngIf="content.type == 'comment'" class="m-0">
                            {{ content.related_objects?.comment?.author?.username }} commented on
                            {{ content.related_objects?.post?.title }}</p>
                        <p *ngIf="content.type == 'comment_liked'" class="m-0">
                            New like on {{ content.related_objects?.comment?.author?.username }}'s
                            comment</p>
                        <p *ngIf="content.type == 'post_liked'" class="m-0">New like on post
                            {{ content.related_objects?.post?.title }}</p>
                        <p *ngIf="content.type == 'post'" class="m-0">New post available
                            {{ content.related_objects?.post?.title }}</p>
                        <small class="muted d-flex align-items-center mt-10 icon">
                            <mat-icon *ngIf="content.type=='comment'">question_answer</mat-icon>
                            <mat-icon
                                    *ngIf="content.type=='comment_liked' || content.type=='post_liked'">
                                favorite
                            </mat-icon>
                            <mat-icon *ngIf="content.type=='post'">library_books</mat-icon>
                            &nbsp;&nbsp;{{ content.created_at | date: 'MMM d, h:mm a' }}</small>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="this.recentActivity && this.recentActivity?.length == 0 && (!loading  && loading != null)"
                 class="flex-row w-100 gap-15">
                <div class="flex-col pb-15">
                    <small class="m-0">You have no recent activities</small>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
